"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationOrder = void 0;
/**
 * Enumeration of possible pagination orders used when fetching a list of entities from the back-end.
 */
var PaginationOrder;
(function (PaginationOrder) {
    /**
     * Ascending order, from lowest to highest.
     */
    PaginationOrder["ASC"] = "asc";
    /**
     * Descending order, from highest to lowest.
     */
    PaginationOrder["DESC"] = "desc";
})(PaginationOrder = exports.PaginationOrder || (exports.PaginationOrder = {}));
//# sourceMappingURL=pagination.js.map